import { queryClient } from '#/layouts/ClientOnlyObeLayout/lib/init';
import { QueryClientProvider as OGQueryClientProvider } from '@tanstack/react-query';
import React from 'react';

export const QueryClientProvider = ({ children }: { children: React.ReactElement }) => <OGQueryClientProvider client={queryClient}>{children}</OGQueryClientProvider>;
